
import workbook from "./workbook.js";

export default {
    install: (app) => {

        // app.component('Outlet', Outlet);

        app.mixin({
            data() {
                return {
                    // foo: 'foooooo',
                }
            }, 

            created() {
                /**
                 * IMPORTANAT: you must include the <Outlet> tag in the App.vue and assign
                 * a reference with the value of "outlet"
                 */
                this.$workbook = workbook;
            }
        })
    }
}